import React, { Component } from 'react';
import { render } from 'react-dom';
import HCPCalcsEditor from '../src/ace';

// import 'hcpgrammar/mode/java';
// import 'hcpgrammar/theme/github';

// import 'hcpgrammar/mode/jsx';
import 'delete-p-cus-brace-jan/theme/monokai';
import 'delete-p-cus-brace-jan/mode/hcpgrammar';
import 'delete-p-cus-brace-jan/snippets/hcpgrammar';
import 'delete-p-cus-brace-jan/ext/language_tools';

function onChange(newValue) {
	console.log('change', newValue);
}

// Render editor
render(
	<HCPCalcsEditor
		mode='hcpgrammar'
		theme='monokai'
		onChange={onChange}
		name='UNIQUE_ID_OF_DIV'
		editorProps={{ $blockScrolling: true }}
	/>,
	document.getElementById('HCPCalcsEditor')
);
